import React, { useState } from "react";

import GatePassInList from "./GatePassInList";
import GatePassInForm from "./GatePassInForm";

const GatePassIn = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
 

  return (
    <>
      {fromIsShown ? (
        <GatePassInForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
      ) : (
        <GatePassInList addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
      )}
    </>
  );
};

export default GatePassIn;
